import SharePointGASender from "./SharePointGASender";

const sharePointGASender = new SharePointGASender()

export {
  sharePointGASender
}